import { tool_pairing_team_army, tool_pairing_team_army_dto } from '@Api';
import { TeamArmy } from '@Models';
import { injectable } from 'inversify';

@injectable()
export class TeamArmyMapper {
  public map(item: tool_pairing_team_army): TeamArmy {
    return {
      id: item.id,
      teamId: item.team_id,
      armyId: item.army_id,
      isUsed: item.is_used,
      name: item.name,
      logo: item.logo,
      playerName: item.player_name ?? '',
    } satisfies TeamArmy as TeamArmy;
  }

  toDto(item: TeamArmy): tool_pairing_team_army_dto {
    return {
      army_id: item.armyId,
      player_name: item.playerName,
    };
  }
}
